const versionLast = "1";

const schemas = {
    1: {
        props: {
            type: "PAGE",
            id: "",
            version: "1",
            properties: {
                groupType: "system",
                type: "content_list",
            },
            style: [],
            components: {
                CONTENT_CONTAINER: {
                    componentsID: ["SECTION_PAGE"],
                },
            },
        },
        assets: {
            components: {
                SECTION_PAGE: {
                    type: "SECTION_PAGE_CONTENT",
                    id: "SECTION_PAGE",
                    version: "1",
                    properties: {
                        isEnable: true,
                    },
                    style: [],
                    data: {
                        type: 'category',
                        categoryID: null,
                        sortBy: 'recently',
                        contentDisplay: 28,
                    }
                },
            },
            propertiesData: [],
            styleData: [],
            data: [],
        },
    }
};
const migrations = [{}];

const upOrDown = (fromVersion, toVersion) => {
    if (fromVersion < toVersion) {
        return "up";
    } else if (fromVersion > toVersion) {
        return "down";
    } else {
        return "same";
    }
};

const migrate = (schema, toVersion = versionLast) => {
    const fromVersion = schema.version;
    const direction = upOrDown(fromVersion, toVersion);
    if (direction === "same") return schema;
    const migration = migrations.find(
        (migration) => migration[direction === "up" ? "from" : "to"] === fromVersion
    );
    const newSchema = migration[direction](schema);
    return migrate(newSchema, toVersion);
};

export default {
    migrate,
    schemas
};